import { render, staticRenderFns } from "./LandownerTypeSettings.vue?vue&type=template&id=94da8e96&"
import script from "./LandownerTypeSettings.vue?vue&type=script&lang=js&"
export * from "./LandownerTypeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports